export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSONString: { input: any; output: any; }
  Time: { input: any; output: any; }
};

export type AssociatedSchedule = {
  __typename?: 'AssociatedSchedule';
  id: Scalars['ID']['output'];
};

export enum CalendarType {
  Broadcast = 'BROADCAST',
  Standard = 'STANDARD'
}

/** Holds user folder information */
export type Folder = {
  __typename?: 'Folder';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Scalars['ID']['output']>;
  reports?: Maybe<Array<UserReport>>;
  schedules?: Maybe<Array<ReportScheduleSummary>>;
};

export type IdNamePair = {
  __typename?: 'IDNamePair';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** PeriodAggregationEnum is the set of aggregation level values for data aggregation on periods */
export enum PeriodAggregationEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** ReportExportFormatEnum is the set of file format supported in the report exporting */
export enum ReportExportFormatEnum {
  ColonDelimited = 'COLON_DELIMITED',
  CommaDelimited = 'COMMA_DELIMITED',
  Excel = 'Excel',
  SemicolonDelimited = 'SEMICOLON_DELIMITED',
  TabDelimited = 'TAB_DELIMITED',
  VerticalbarDelimited = 'VERTICALBAR_DELIMITED'
}

/** ReportScheduleSummary */
export type ReportScheduleSummary = {
  __typename?: 'ReportScheduleSummary';
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expireDateTime: Scalars['Time']['output'];
  fileFormat: ReportExportFormatEnum;
  folderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  recurrencePattern: Scalars['String']['output'];
  source: Scalars['String']['output'];
  startDateTime: Scalars['Time']['output'];
  timezone: Scalars['String']['output'];
};

/** Response type carrying the saved name in case it is different from the one sent along with the id. */
export type SaveResponse = {
  __typename?: 'SaveResponse';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum ServerErrorCode {
  BadUserInput = 'BAD_USER_INPUT',
  Forbidden = 'FORBIDDEN',
  InternalSystemError = 'INTERNAL_SYSTEM_ERROR',
  ReportNameExists = 'REPORT_NAME_EXISTS',
  ReportNotFound = 'REPORT_NOT_FOUND',
  ScheduleNameExists = 'SCHEDULE_NAME_EXISTS',
  ScheduleNotFound = 'SCHEDULE_NOT_FOUND',
  Unauthenticated = 'UNAUTHENTICATED'
}

/** StringComparisonEnum is the set of valid options for custom filter strings. */
export enum StringComparisonEnum {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  None = 'NONE',
  StartsWith = 'STARTS_WITH'
}

/** UserReport is the type returned by the list user reports API. */
export type UserReport = {
  __typename?: 'UserReport';
  associatedSchedules: Array<Maybe<AssociatedSchedule>>;
  created: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiresOn: Scalars['Int']['output'];
  folderId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastModified: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nationId: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  shared: Scalars['Boolean']['output'];
  typeId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};
